import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const DayRate: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <NumberField
    name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.DayRate}`}
    label={'Day Rate'}
    placeholder={'$0.0000'}
    mode={'currency'}
    data-test-id={'fee-detail-day-rate'}
    decimalScale={4}
    readOnly={readOnly}
  />
);
